'use client'
import Marquee from "react-fast-marquee";
import {LogoCloudProps} from "@/shared/pages/logoCloudShared";
import {consts} from "@/shared/commonShared";
import ExportedImage from "next-image-export-optimizer";

export default function LogoCloud({ logos }: LogoCloudProps) {
	if (!logos || logos.length === 0) return null;

	return (
		<div className={"section-logo-cloud container-fluid mt-lg-0 border-top border-bottom py-"+consts.PADDING}>
			<div className="container">
				<h5 className="ds-6 text-center">Our Partners</h5>

				<div className="row mask-image">
					{/* fixed height wrapper so nothing jumps when logos load */}
					<div
						className={"carouselTicker carouselTicker-right mt-"+consts.PADDING+" position-relative z-1"}
						style={{minHeight: 60}} // adjust to your design
					>
						<ul className="carouselTicker__list m-0 p-0 list-unstyled">
							<Marquee pauseOnHover={true} speed={40}>
								{logos.map((logo) => (
									<li
										className="carouselTicker__item d-flex align-items-center mx-3"
										key={logo.id}
									>
										{logo.src ? (
											<ExportedImage
												   src={logo.src}
												   alt={logo.alt || 'Partner logo'}
												   width={160}
												   height={40} // 4:1-ish, adjust as needed
												   sizes="(max-width: 768px) 30vw, 10vw"
												   className="img-fluid object-fit-contain"
											/>
										) : (
											<svg
												className="mt-1"
												xmlns="http://www.w3.org/2000/svg"
												width={101}
												height={34}
												viewBox="0 0 101 34"
												aria-hidden="true"
											>
												<path d={logo.svgPath} fill="#111827"/>
											</svg>
										)}
									</li>
								))}
							</Marquee>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}
